import { render, staticRenderFns } from "./NewLeaveRequestPlain.vue?vue&type=template&id=882da49a&scoped=true&"
import script from "./NewLeaveRequestPlain.vue?vue&type=script&lang=js&"
export * from "./NewLeaveRequestPlain.vue?vue&type=script&lang=js&"
import style0 from "./NewLeaveRequestPlain.vue?vue&type=style&index=0&id=882da49a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882da49a",
  null
  
)

export default component.exports